module.exports = __webpack_public_path__ + "./fonts/NeutraText-Bold.ttf";